import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  Title,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement
);

const DonutChart = ({ serviceSet, servicePercentages, smallVersion }) => {
  const labels = Array.from(serviceSet); // Convert Set to Array for labels
  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Potential Cost Saving',
        data: labels.map(label => parseFloat(servicePercentages[label])), // Map service percentages to data array
        backgroundColor: [
          'pink',
          '#17a2b8',
          '#ffc107',
          'rgb(87, 185, 96)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const getOptions = (smallVersion) => ({
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        labels: {
          boxWidth: smallVersion ? 6 : 10,  // Adjust box width for small and large versions
          boxHeight: smallVersion ? 6 : 10, // Adjust box height for small and large versions
          font: {
            size: smallVersion ? 7 : 14, // Adjust font size for small and large versions
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.raw || 0;
            return `${label}: ${value}%`;
          }
        }
      }
    },
    cutout: smallVersion ? '70%' : '50%', // Adjust the size of the donut hole
  });

  // Set the height and width of the chart based on the `smallVersion` prop
  const chartHeight = smallVersion ? '60px' : '200px';
  const chartWidth = '100%';

  return (
    <div style={{ height: chartHeight, width: chartWidth }}>
      <Doughnut data={data} options={getOptions(smallVersion)} />
    </div>
  );
};

export default DonutChart;
